import { ChangeDetectionStrategy, Component, inject, Input, NgZone, OnDestroy, OnInit, signal, WritableSignal } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { RouterOutlet } from '@angular/router';
import { AppHeaderComponent } from '../../app-header/app-header.component';
import { AppFooterComponent } from '../../app-footer/app-footer.component';
import { MaintenanceService } from '../../../services/maintenance.service';
import { AsyncPipe } from '@angular/common';
import { LoadingSpinnerComponent } from "../../loading-spinner/loading-spinner.component";

@Component({
  selector: 'app-shell',
  standalone: true,
  imports: [RouterOutlet, AppHeaderComponent, AppFooterComponent,  AsyncPipe, LoadingSpinnerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './shell.component.html',
  styleUrl: './shell.component.scss'
})
export class ShellComponent implements OnInit, OnDestroy {
  maintenanceStatus$!: Observable<boolean>
  @Input() loading = signal(true)
  destroy = new Subject<null>()
  
  constructor(private maintenanceService: MaintenanceService) { }
  
  ngOnDestroy(): void {
    this.destroy.next(null);
    this.destroy.unsubscribe()
  }

  ngOnInit(): void {
    this.maintenanceCheck()
  }

  maintenanceCheck() {
    this.maintenanceStatus$ = of(false)
    this.maintenanceStatus$ = this.maintenanceService.getProcessingStatus();
  }

  

}
